<template>
<div class="nav-container">
    <router-link to="/">Aktuelles</router-link>
    <router-link to="/angebote">Angebote</router-link>
    <router-link to="/infothek">Infothek</router-link>
    <router-link to="/ueber-uns">Über uns</router-link>
</div>
</template>

<script>

export default {
  name: "Navigation",
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/main.scss';

.nav-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 38px;
  background-color: $primaryDark;
  
  a {
    color: $white;
    padding:10px;
  }

  a:hover,
  a:active,
  a.router-link-exact-active {
    border-radius: 10px;
    background-color: $white;
    color: $primaryDark;
  }

}
</style>